<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <SiruiSearch
      ref="searchRef"
      :query="queryData"
      :columns="topColumns"
      :isQueryPanel="true"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchTrigger"
      @changeMethod="changeMethod"
    >
    </SiruiSearch>

    <div class="result-table">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        @chooseClick="chooseClick"
        :loading="loading"
        @handleSelectionChange="handleSelectionChange"
        @handleSizeChange="() => getSummarizeList()"
        @handleCurrentChange="() => getSummarizeList()"
        :cellClick="cellClick"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :cellStyle="cellStyle"
        :columns="tableColumns"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        :showFooter="1 == 1"
      >
        <vxe-table-column type="checkbox" width="50"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumns"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
        </vxe-table-column>
      </sirui-table>
    </div>
  </el-card>
</template>

<script>
  import DEPOSITAPI from '@/api/reportManagement';
  import API from '@/api/masterData/company.js';
  import { summarizSearchColumns, summarizeTableColumns } from './columns';
  import ReportMixin from './mixins/reportMixin';
  import moment from 'moment';
  export default {
    name: 'summarizing',
    mixins: [ReportMixin],
    data() {
      return {
        loading: false,
        tableColumns: [],
        menuButtonList: [], // 表格功能按钮
        selectedItems: [],
        tableData: [],
        queryData: {
          contractCompanyNo: null,
          contractDepartmentNo: null,
          receivableAccountPeriod: null,
          expenseType: null,
        },
        footerTotalCols: {
          amount: [
            'beginPeriodNotReceived',
            'currentReceivables',
            'totalReceivables',
            'currentReceived',
            'totalReceived',
            'finalNotReceived',
          ],
          quantity: [],
        },
        companyName: '',
        departmentName: '',
      };
    },
    computed: {
      topColumns() {
        return summarizSearchColumns(this);
      },
    },
    async mounted() {
      this.queryData.contractCompanyNo = this.userInfo.companyCode;
      await this.department(this.userInfo.companyCode);
      this.queryData.contractDepartmentNo = this.userInfo.departmentCode;
      this.queryData.receivableAccountPeriod = moment(new Date()).format('yyyy-MM');
      this.companyName = this.userInfo.companyName;
      this.departmentName = this.userInfo.departmentName;
      // this.$refs.siruiTable.setPageSize(10);
      this.getSummarizeList();
      this.getButtonList();
    },
    methods: {
      footerMethodTotal({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            for (let key in this.footerTotalCols) {
              if (this.footerTotalCols[key].includes(column.property)) {
                let total = this.$utils.calSum(data, column.property);
                let point = this.$globalVar.aPoint;
                if (key == 'quantity') {
                  point = this.$globalVar.qPoint;
                }
                total = this.$utils.commafy(this.$utils.toNumber(total).toFixed(point), point);
                return total;
              }
            }
          }),
        ];
      },
      async resetBtnClick() {
        // this.$refs.siruiTable.setPageNum(1);
        // this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.selectedItems = [];
        this.queryData.contractCompanyNo = this.userInfo.companyCode;
        await this.department(this.userInfo.companyCode);
        this.queryData.contractDepartmentNo = this.userInfo.departmentCode;
        this.queryData.receivableAccountPeriod = moment(new Date()).format('yyyy-MM');
        this.companyName = this.userInfo.companyName;
        this.departmentName = this.userInfo.departmentName;
        this.getSummarizeList();
      },
      // 搜索
      searchTrigger() {
        // this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getSummarizeList();
        this.getCompanyDepartmentName();
      },
      // 获取列表
      async getSummarizeList() {
        let params = { ...this.queryData };
        // params.pageNum = this.$refs.siruiTable.page.pageNum;
        // params.pageSize = this.$refs.siruiTable.page.pageSize;
        // if (params.customerName) {
        //   params.customerCode = params.customerName[0].partnerCode;
        //   params.customerName = params.customerName[0].partnerZhName;
        // }
        params = this.filterEmpty(params);
        // console.log('processedParams', params);
        this.loading = true;
        const { data } = await this.$axios.post(DEPOSITAPI.STORAGE_SUMMARIZING_LIST, params);
        console.log(data, '汇总数据');
        if (data && data.code == 0) {
          console.log('depositRes', data.data);
          this.tableData = data.data || [];
          // this.$refs.siruiTable.setPageTotal(data.data.total);
          // this.$refs.siruiTable.setPageSize(data.data.size);
        } else {
          this.$message.error(data.msg);
        }
        // //清空选择fixme
        this.selectedItems = [];
        this.loading = false;
      },
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(summarizeTableColumns()).then(() => {
          this.tableColumns = summarizeTableColumns();
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          console.log('menuButtons', this.menuButtonList);
          this.getColumnInfo();
        });
      },
      // 表格上面的按钮
      async chooseClick(type) {
        console.log(this.selectedItems);
        let empty = !this.selectedItems || !this.selectedItems.length;
        let justOne = this.selectedItems.length == 1;
        if (empty && type != 'export') {
          this.$message.error('请选择数据！');
          return;
        }
        if (!justOne && type != 'export') {
          this.$message.error('请选择一条数据！');
          return;
        }

        switch (type) {
          case 'export':
            this.handleExport(this.selectedItems);
            break;
          default:
            break;
        }
      },
      async handleExport(items) {
        let api = DEPOSITAPI.STORAGE_EXPORT;
        if (!items.length) {
          items = this.tableData;
        }
        if (items.length) {
          let obj = {
            companyName: this.companyName,
            departmentName: this.departmentName,
            receivableAccountPeriod: this.queryData.receivableAccountPeriod,
            loginPerson: this.userInfo.personName,
          };
          let list = {
            ...items[0],
            ...obj,
          };
          items[0] = list;
          await this.$axios.post(api, items).then((res) => {
            console.log(res, 'export res');
            if (res.data.code === 0) {
              window.location.href = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else {
          this.$message.error('暂无导出数据');
        }
      },
      async getCompanyDepartmentName() {
        await this.$axios
          .get(API.GET_DEPARTMENT_DETAIL_API + '/' + this.queryData.contractDepartmentNo)
          .then((res) => {
            if (0 == res.data.code) {
              this.companyName = res.data.data.company.createCompanyName;
              this.departmentName = res.data.data.departmentDetail.createDepartmentName;
            }
          });
      },
      handleSelectionChange(row) {
        this.selectedItems = row;
        console.log(row);
      },
      cellStyle({ column }) {
        if (column.property == 'expenseTypeName') {
          return {
            color: '#009fcc',
          };
        }
      },
      cellClick(val) {
        if (val.column?.property == 'expenseTypeName') {
          this.$router.push({
            name: `detailAccount`,
            params: val.row,
          });
          console.log('clickContract', val.row);
        }
      },
    },
  };
</script>

<style></style>
